import DataTable from 'react-data-table-component';
import StyledAllocations from './styles';
import useAllocatedAddressesTypes from './useAllocatedAddressesTypes';

const AllocatedAddresses = ({
    isShown, types, initialTypes, filterDate, addressSearch, distributionAllocationType,
}) => {
    const {
        loading,
        totalRows,
        filteredData,
        columns,
        perPage,
        handlePerRowsChange,
        getData,
    } = useAllocatedAddressesTypes(types, initialTypes, filterDate, addressSearch, distributionAllocationType);

    return (
        <StyledAllocations isShown={isShown}>
            <DataTable
                columns={columns}
                data={filteredData}
                onChangePage={(currPage) => getData(currPage)}
                progressPending={loading}
                subHeaderAlign="center"
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationRowsPerPageOptions={[20, 50, 70, 100]}
                paginationPerPage={perPage}
            />
        </StyledAllocations>
    );
};

export default AllocatedAddresses;
